import { Patient } from "pwapi";

import CustomInput from "components/customInputs/CustomInput";

import { PatientOption } from "../edit/ResourceOptions";

const FlatPatientField = ({ patient }: { patient?: Patient }) => {
  return (
    <CustomInput label="Patient">
      <div className="patientField">
        {patient ? <PatientOption object={patient} /> : <>Missing Patient</>}
      </div>
    </CustomInput>
  );
};

export default FlatPatientField;
